// extracted by mini-css-extract-plugin
export default {"element":"CoreQuote-module--element--1333e"};